module.exports = {
      id: "mail-usage",
      viewBox: "0 0 19 16",
      url: __webpack_public_path__ + "svg-sprite-f952e3bcb1151291994742cd359b350c.svg#mail",
      toString: function () {
        return this.url;
      }
    }